import Label from '../../Utils/FormInputs/Label';
import TextField from '../../Utils/FormInputs/TextField';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  label: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  required: {
    color: theme.palette.error.main,
    marginLeft: 2,
  },
  noteField: {
    marginLeft: 32,
    marginTop: 4,
  },
  checkboxRoot: {
    paddingTop: 4,
  },
}));

/**
 * Reusable checklist row used in WHO Checklist, Pre-Op Checklist,
 * Discharge Checklist, and Pre-Admission Checklist
 */
const ChecklistItem = ({
  label,
  checked = false,
  onChange,
  required = false,
  showNote = false,
  noteValue = '',
  onNoteChange,
  disabled = false,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div style={{ flex: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={onChange}
              color="primary"
              size="small"
              disabled={disabled}
              classes={{ root: classes.checkboxRoot }}
            />
          }
          label={
            <Typography className={classes.label}>
              {label}
              {required && <span className={classes.required}>*</span>}
            </Typography>
          }
        />
        {showNote && checked && (
          <TextField
            className={classes.noteField}
            placeholder="Add a note (optional)"
            value={noteValue}
            onChange={onNoteChange}
            size="small"
            fullWidth
            variant="outlined"
            disabled={disabled}
            multiline
            rowsMax={2}
          />
        )}
      </div>
    </div>
  );
};

export default ChecklistItem;
